export enum SocketMessages {
  START_VOTING = 'start-voting',
  STOP_VOTING = 'stop-voting',
  SEND_VOTE = 'send-vote',
  UPDATE_QUORUM = 'update-quorum'
}